module.exports = __webpack_public_path__ + "static/img/header.9840053.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/header.png
// module id = Kk6m
// module chunks = 1